import { z } from 'zod';

export const ACTION = z.enum(['PAYMENT_TYPE_CREATE', 'PAYMENT_TYPE_UPDATE', 'PAYMENT_TYPE_DELETE', 'TERM_DISCOUNT_CREATE', 'TERM_DISCOUNT_UPDATE']);

export type ActionType = z.infer<typeof ACTION>;
